export default "__VITE_ASSET__C4ZHP9zI__"